<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo">Dados da Empresa</h1>
        <p class="paragrafo mb-4">Mantenha os dados sempre atualizados</p>

        @if (dadosEmpresa) {
          <div class="row">
            <div class="col-6 col-md-6 col-lg-3">
              <span class="titulos-api">CNPJ</span>
              <p class="dados-api text-nowrap">{{$safeNavigationMigration(dadosEmpresa?.cdCdcnpjEmp) | cnpj}}</p>
            </div>
            <div class="col-6 col-md-6 col-lg-6 col-xl-2">
              <span class="titulos-api">Número do contrato</span>
              <p class="dados-api">128332</p>
            </div>
            <div class="col-12 col-md-6 col-lg-6 col-xl-4">
              <span class="titulos-api">Meio de pagamento</span>
              <p class="dados-api">{{$safeNavigationMigration(dadosEmpresa?.dsMeipagMpg) | camelCase}}</p>
            </div>
          </div>
        }


        @if (dadosEmpresa) {
          <div>
            <!-- NAVEGAÇÃO DAS ABAS DO DETALHAMENTO DO PEDIDO -->
            <ul class="nav nav-tabs border-0 mt-4 mb-4" id="myTab">
              <li class="nav-item">
                <a class="nav-link active ps-0" id="empresaTab" data-bs-toggle="tab" href="#empresa" role="tab" aria-controls="empresa" aria-selected="true">Empresa</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="filiaisTab" data-bs-toggle="tab" href="#filiais" role="tab" aria-controls="filiais" aria-selected="true">Filiais</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="enderecoTab" data-bs-toggle="tab" href="#endereco" role="tab" aria-controls="endereco" aria-selected="true">Endereços</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="contatosTab" data-bs-toggle="tab" href="#contatos" role="tab" aria-controls="contatos" aria-selected="true">Contatos</a>
              </li>
            </ul>
            <!-- Conteúdo das TABS (navegação entre as abas) -->
            <div class="tab-content" id="myTabContent">
              <!-- ABA DA EMPRESA -->
              <div class="tab-pane fade show active" id="empresa" role="tabpanel" aria-labelledby="empresaTab">
                <div class="col-12">
                  <app-dados-empresa-empresa></app-dados-empresa-empresa>
                </div>
              </div>
              <!-- ABA DE FILIAIS -->
              <div class="tab-pane fade" id="filiais" role="tabpanel" aria-labelledby="filiaisTab">
                <div class="col-12">
                  <app-dados-empresa-filiais></app-dados-empresa-filiais>
                </div>
              </div>
              <!-- ABA DE ENDEREÇO -->
              <div class="tab-pane fade" id="endereco" role="tabpanel" aria-labelledby="enderecoTab">
                <div class="col-12">
                  <app-dados-empresa-enderecos></app-dados-empresa-enderecos>
                </div>
              </div>
              <!-- ABA DE CONTATOS -->
              <div class="tab-pane fade" id="contatos" role="tabpanel" aria-labelledby="contatosTab">
                <div class="col-12">
                  <app-dados-empresa-contatos></app-dados-empresa-contatos>
                </div>
              </div>
            </div>
          </div>
        }

        <!-- CARREGAMENTO EMPRESAS -->
        @if (dadosEmpresa === null) {
          <div>
            <div class="text-center">
              <output class="spinner-border c-primary">
                <span class="visually-hidden">Consultando dados da empresa ...</span>
              </output>
            </div>
            <p class="legenda-spinner">Consultando dados da empresa ...</p>
          </div>
        }

        <!-- CASO DE ERRO EMPRESAS -->
        @if (dadosEmpresa === false) {
          <div class="text-center">
            <img src="/assets/img/erro.png" width="200px" alt="Erro">
            <p class="legenda-erro">Ocorreu um erro na consulta dos dados da empresa.</p>
          </div>
        }

      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
